import { render } from "./ChannelPost.vue?vue&type=template&id=9a200a30&scoped=true"
import script from "./ChannelPost.vue?vue&type=script&lang=js"
export * from "./ChannelPost.vue?vue&type=script&lang=js"

import "./ChannelPost.vue?vue&type=style&index=0&id=9a200a30&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a200a30"]])

export default __exports__